import { useState, useEffect } from 'react';
import { Col, Row, Input, Label, Spinner } from 'reactstrap';
import { Search, ChevronDown, ChevronUp, Send } from 'react-feather';
import OptionsForm from '../../layouts/forms/OptionsForm';
import Loader from '../../layouts/loader/Loader';
import TablaTutores from './TablaTutores';
import ModalOption from '../../layouts/modals/ModalOption';
import ModalClickable from '../../layouts/modals/ModalClickable';
import documentosApiService from '../../services/http/documentosApiService';
import colors from '../../theme/colors';
import otrosApiService from '../../services/http/otrosApiService';

const FormularioBoletines = () => {
  const [showFilters, setShowFilters] = useState(true);
  const [isShown, setIsShown] = useState(false);
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [isError, setIsError] = useState(false);
  const [selected, setSelected] = useState([]);
  const [tutores, setTutores] = useState('');
  const [dataApi, setDataApi] = useState('');
  const [headquarter, setHeadquarter] = useState('');
  const [courseYear, setCourseYear] = useState('');
  const [course, setCourse] = useState('');
  const [isEmpty, setIsEmpty] = useState(false);
  const [type, setType] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataOpcionesSII = await otrosApiService.cargarOpcionesSII();
        setDataApi(dataOpcionesSII);
        setHeadquarter(dataOpcionesSII.centre[0].codigo);
        setCourseYear(dataOpcionesSII.curs[0].codigo);
        setCourse(dataOpcionesSII.grau[0].codigo);
        setType(dataOpcionesSII.modalitat[0].codigo);
      } catch (error) {
        setDataApi('');
        setHeadquarter('');
        setCourseYear('');
        setCourse('');
        setType('');
      }
    };

    fetchData();
  }, []);

  const handleHeadquarter = (e) => setHeadquarter(e.target.value);
  const handleCourseYear = (e) => setCourseYear(e.target.value);
  const handleCourse = (e) => setCourse(e.target.value);
  const handleType = (e) => setType(e.target.value);

  const sendData = async () => {
    try {
      const dataEnvioBolnot = await documentosApiService.generarEnvioBolnot({
        headquarter,
        alumnos: selected,
      });

      if (!dataEnvioBolnot.itWorked) {
        setIsDownloaded(true);
      } else {
        setIsError(true);
      }
    } catch (error) {
      // Error silencioso
    }
  };

  const onCheckboxChange = (element) => {
    setSelected((prevSelected) =>
      prevSelected.some((item) => item.id === element.id)
        ? prevSelected.filter((item) => item.id !== element.id)
        : [...prevSelected, element],
    );
  };

  const onSeleccionarVarias = (filas, marcar) => {
    setSelected((prevSelected) => {
      const ids = new Set(filas.map((f) => f.id));
      const resto = prevSelected.filter((item) => !ids.has(item.id));
      return marcar ? [...resto, ...filas] : resto;
    });
  };

  const loadData = async () => {
    setIsLoadingSpinner(true);

    try {
      const dataTutores = await otrosApiService.buscarTutores({
        centre: headquarter,
        curso: courseYear,
        grau: course,
        modalitat: type,
      });

      setTutores(dataTutores);
      setSelected([]);
    } catch (error) {
      setTutores('');
    } finally {
      setIsLoadingSpinner(false);
    }
  };

  const showModal = async () => {
    await loadData();
    if (selected.length > 0) {
      setIsShown(!isShown);
    } else {
      setIsEmpty(!isEmpty);
    }
  };

  const isAllSelected = tutores !== '' && tutores.length > 0 && selected.length === tutores.length;

  const handleToggleAll = () => {
    if (isAllSelected) {
      setSelected([]);
    } else {
      setSelected([...tutores]);
    }
  };

  const toolbarButtons = (
    <>
      <button
        type="button"
        onClick={loadData}
        disabled={isLoadingSpinner}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '5px',
          padding: '6px 14px',
          fontSize: '0.75rem',
          fontWeight: 600,
          borderRadius: '6px',
          border: 'none',
          backgroundColor: colors.primary,
          color: '#fff',
          cursor: isLoadingSpinner ? 'not-allowed' : 'pointer',
          opacity: isLoadingSpinner ? 0.5 : 1,
          transition: 'all 0.15s',
        }}
      >
        {isLoadingSpinner ? (
          <Spinner style={{ height: '13px', width: '13px' }} />
        ) : (
          <Search size={13} />
        )}
        {isLoadingSpinner ? 'Buscando...' : 'Buscar'}
      </button>
      {tutores !== '' && tutores.length > 0 && (
        <button
          type="button"
          onClick={handleToggleAll}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            padding: '6px 14px',
            fontSize: '0.75rem',
            fontWeight: 600,
            borderRadius: '6px',
            border: '1px solid #e5e7eb',
            backgroundColor: '#fff',
            color: '#374151',
            cursor: 'pointer',
            transition: 'all 0.15s',
          }}
        >
          {isAllSelected ? 'Desmarcar todos' : 'Marcar todos'}
        </button>
      )}
      {tutores !== '' && (
        <button
          type="button"
          onClick={showModal}
          disabled={isLoadingSpinner}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            padding: '6px 14px',
            fontSize: '0.75rem',
            fontWeight: 600,
            borderRadius: '6px',
            border: `1px solid ${colors.primary}`,
            backgroundColor: '#fff',
            color: colors.primary,
            cursor: isLoadingSpinner ? 'not-allowed' : 'pointer',
            opacity: isLoadingSpinner ? 0.5 : 1,
            transition: 'all 0.15s',
          }}
        >
          <Send size={13} />
          Enviar
        </button>
      )}
    </>
  );

  return (
    <>
      {isDownloaded ? (
        <ModalClickable
          color="primary"
          header="Petición recibida correctamente. El archivo se enviará a todos los tutores."
        />
      ) : (
        ''
      )}
      {isError ? (
        <ModalClickable header="Ha surgido un error. Consulte con el administrador." />
      ) : (
        ''
      )}
      {isShown ? (
        <ModalOption
          sendData={sendData}
          header="¿Desea enviar el boletín a todos los tutores de alumnos menores?"
        />
      ) : (
        ''
      )}
      {isEmpty ? <ModalClickable color="primary" header="No ha seleccionado tutores." /> : ''}

      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
          overflow: 'visible',
        }}
      >
        {/* Toolbar */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 16px',
            borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
          }}
        >
          <button
            type="button"
            onClick={() => setShowFilters(!showFilters)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '0.8rem',
              fontWeight: 600,
              color: '#374151',
              padding: '4px 8px',
              borderRadius: '6px',
            }}
          >
            <Search size={15} style={{ color: '#9ca3af' }} />
            Filtros
            {showFilters ? (
              <ChevronUp size={14} style={{ color: '#9ca3af' }} />
            ) : (
              <ChevronDown size={14} style={{ color: '#9ca3af' }} />
            )}
          </button>
          <div style={{ display: 'flex', gap: '8px' }}>{toolbarButtons}</div>
        </div>

        {/* Filtros colapsables */}
        {showFilters && (
          <div
            style={{
              padding: '16px',
              opacity: isLoadingSpinner ? 0.5 : 1,
              pointerEvents: isLoadingSpinner ? 'none' : 'auto',
              transition: 'opacity 0.2s',
            }}
          >
            {dataApi !== '' ? (
              <>
                <Row className="mb-3">
                  <Col sm className="mt-2 mt-md-0">
                    <Label for="centros">Centro</Label>
                    <Input type="select" name="centros" id="centros" onChange={handleHeadquarter}>
                      <OptionsForm datos={dataApi.centre} />
                    </Input>
                  </Col>
                  <Col sm className="mt-2 mt-md-0">
                    <Label for="curso">Curso</Label>
                    <Input type="select" name="curso" id="curso" onChange={handleCourseYear}>
                      <OptionsForm datos={dataApi.curs} />
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col sm className="mt-2 mt-md-0">
                    <Label for="modalidad">Modalidad</Label>
                    <Input type="select" name="modalidad" id="modalidad" onChange={handleType}>
                      <OptionsForm datos={dataApi.modalitat} />
                    </Input>
                  </Col>
                  <Col sm className="mt-2 mt-md-0">
                    <Label for="grado">Grado</Label>
                    <Input type="select" name="grado" id="grado" onChange={handleCourse}>
                      <OptionsForm datos={dataApi.grau} />
                    </Input>
                  </Col>
                </Row>
              </>
            ) : (
              <Loader />
            )}
          </div>
        )}
      </div>

      {tutores !== '' ? (
        <TablaTutores
          data={tutores}
          selected={selected}
          onCheckboxChange={onCheckboxChange}
          onSeleccionarVarias={onSeleccionarVarias}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default FormularioBoletines;
